import { useEffect } from 'react';
import { useAppDispatch } from '@/app/hooks';
import { useGetLoggedInUserDataQuery } from '../api/authApi';
import { sessionEstablished, sessionCheckFinished } from '../constants/sessionSlice';

/**
 * Props:
 *   children  the app tree, rendered once the session check settles
 */
export const SessionBootstrap = ({ children }) => {
  const dispatch = useAppDispatch();
  const { data: user, isSuccess, isError } = useGetLoggedInUserDataQuery();

  useEffect(() => {
    if (isSuccess) dispatch(sessionEstablished(user));
    else if (isError) dispatch(sessionCheckFinished());
  }, [isSuccess, isError, user, dispatch]);

  return children;
};
